// ---------------------------------------------------------------------------
// Export ข้อมูลร้านเป็น Excel — logic ล้วน เทสต์ได้
// ---------------------------------------------------------------------------
// dataset = ชุดข้อมูลที่เลือก export ได้ ผูกกับโมดูล (ร้านเห็นเฉพาะโมดูลที่ใช้ได้) และ field วันที่ที่ใช้กรองช่วงวัน
// repo อยู่ในหน้า Export (ดึงเฉพาะ org ของร้านตัวเอง) ไฟล์นี้ไม่รู้จัก service
// ---------------------------------------------------------------------------

export const EXPORT_DATASETS = [
  { key: "customers", repo: "customerRepo", module: "crm", name: "ลูกค้า", nameEn: "Customers", dateField: "createdAt" },
  { key: "leads", repo: "leadRepo", module: "crm", name: "ลีด", nameEn: "Leads", dateField: "createdAt" },
  { key: "appointments", repo: "appointmentRepo", module: "booking", name: "นัดหมาย", nameEn: "Appointments", dateField: "startAt" },
  { key: "products", repo: "productRepo", module: "catalog", name: "สินค้า & บริการ", nameEn: "Products & services", dateField: "createdAt" },
  { key: "inventory", repo: "inventoryRepo", module: "inventory", name: "สต็อกคงเหลือ", nameEn: "Stock on hand", dateField: "createdAt" },
  { key: "stockMoves", repo: "stockMoveRepo", module: "inventory", name: "ความเคลื่อนไหวสต็อก", nameEn: "Stock movements", dateField: "createdAt" },
  { key: "quotations", repo: "quotationRepo", module: "billing", name: "ใบเสนอราคา", nameEn: "Quotations", dateField: "createdAt" },
  { key: "invoices", repo: "invoiceRepo", module: "billing", name: "ใบแจ้งหนี้", nameEn: "Invoices", dateField: "createdAt" },
  { key: "receipts", repo: "receiptRepo", module: "billing", name: "ใบเสร็จ", nameEn: "Receipts", dateField: "createdAt" },
  { key: "salesOrders", repo: "salesOrderRepo", module: "oms", name: "ออเดอร์", nameEn: "Orders", dateField: "createdAt" },
  { key: "posSales", repo: "posSaleRepo", module: "pos", name: "ขายหน้าร้าน (POS)", nameEn: "POS sales", dateField: "createdAt" },
  { key: "contracts", repo: "contractRepo", module: "contract", name: "สัญญา", nameEn: "Contracts", dateField: "createdAt" },
];

const dayStart = (value) => new Date(`${value}T00:00:00`);
const dayEnd = (value) => new Date(`${value}T23:59:59.999`);

/** กรองแถวตามช่วงวันที่ (รวมวันแรกและวันสุดท้าย) · ไม่ระบุช่วง = ทั้งหมด · มีช่วงแต่แถวไม่มีวันที่ที่อ่านได้ = ไม่รวม */
export const filterByRange = (rows, field, from, to) => {
  const list = Array.isArray(rows) ? rows : [];
  if (!from && !to) return list;
  const min = from ? dayStart(from) : null;
  const max = to ? dayEnd(to) : null;
  return list.filter((row) => {
    const date = new Date(row?.[field]);
    if (Number.isNaN(date.getTime())) return false;
    return (!min || date >= min) && (!max || date <= max);
  });
};

/** ช่วงวันที่ไม่ถูกต้อง (จบก่อนเริ่ม) -> ข้อความ error ไทย · ผ่าน = "" */
export const validateRange = (from, to) => {
  if (from && Number.isNaN(dayStart(from).getTime())) return "วันที่เริ่มต้นไม่ถูกต้อง";
  if (to && Number.isNaN(dayStart(to).getTime())) return "วันที่สิ้นสุดไม่ถูกต้อง";
  if (from && to && dayStart(from) > dayStart(to)) return "วันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่มต้น";
  return "";
};

// เซลล์ Excel เก็บข้อความได้ไม่เกิน 32,767 ตัวอักษร
const CELL_MAX = 32000;

/** แถวสำหรับ Excel: ค่า object/array เป็น JSON · ตัดคอลัมน์ภายในของระบบ (org_id) ออก */
export const flattenRow = (row) => {
  const out = {};
  Object.entries(row || {}).forEach(([key, value]) => {
    if (key === "org_id") return;
    if (value === null || value === undefined) out[key] = "";
    else if (typeof value === "object") out[key] = JSON.stringify(value).slice(0, CELL_MAX);
    else out[key] = typeof value === "string" ? value.slice(0, CELL_MAX) : value;
  });
  return out;
};

/** ป้องกันข้อมูลข้ามร้าน: เก็บเฉพาะแถวที่ไม่มี org_id (โหมด local) หรือ org_id ตรงกับร้านนี้ */
export const onlyOrg = (rows, orgId) => (Array.isArray(rows) ? rows : []).filter((row) => !row?.org_id || String(row.org_id) === String(orgId));
